module.exports = __webpack_public_path__ + "static/media/arrow_white.bf8db0e1.svg";